// extracted by mini-css-extract-plugin
export default {"form":"form___dv5sS","collapse":"collapse___zeeka","wrapper":"wrapper___Olsqz"};